<template>
  <page-outline :title="$t('pacs008.transaction_list_SDD')">
    <template slot="pageContent">
      <!-- FILTRES MOBILE -->
      <div v-if="isSmartphoneOS" slot="fixed">
        <div style="position: absolute; top: 44px; width: 100%">
          <cm-messages-filter
            class="researchfilter"
            style="position: relative; z-index: 10"
            propedServiceId="10"
            filterType="list"
            :mode="this.mode"
            @applyFilter="applyFilter($event)">
          </cm-messages-filter>
        </div>
      </div>

      <div class="listPage" style="overflow: hidden">
        <b-row class="mx-0">
          <b-col cols="12">
            <div class="requestsList">
              <div v-if="!isSmartphoneOS">
                <cm-messages-filter
                  class="researchfilter"
                  style="position: relative; z-index: 10"
                  filterType="list"
                  format="SDD"
                  :mode="this.mode"
                  @applyFilter="applyFilter($event)"
                  propedServiceId="10"
                  :countResults="paginationObject.nbResultsTotal.toString()">
                </cm-messages-filter>
              </div>
              <div v-if="isSmartphoneOS" :style="customMobileLayoutStyle"></div>
            </div>

            <br />

            <b-row class="justify-content-center">
              <b-col sm="12">
                <hr class="w-100" />
              </b-col>
            </b-row>

            <br />

            <b-row class="form-group justify-content-start m-0 p-0">
              <b-col sm="2" cols="6" class="m-0 p-0">
                <div
                  :class="{
                    'active-tab': currentTab === 'list',
                    'inactive-tab': currentTab !== 'list',
                  }"
                  class="mr-2 text-left cursor"
                  size="sm"
                  @click="changeCurrentTab('list')">
                  <i class="fa-duotone fa-file"></i>
                  {{ $t("pacs008.transaction_list") }}
                </div>
              </b-col>
              <b-col sm="2" cols="6" class="m-0 p-0">
                <div
                  :class="{
                    'active-tab': currentTab === 'data',
                    'inactive-tab': currentTab !== 'data',
                  }"
                  class="mr-2 text-left cursor"
                  size="sm"
                  @click="changeCurrentTab('data')">
                  <i class="fa-duotone fa-file-lines"></i>
                  {{ $t("pacs008.transaction_details") }}
                </div>
              </b-col>
            </b-row>
            <br />
            <spinner v-if="activateSpinner"></spinner>
            <div v-else-if="currentTab === 'list'">
              <b-table
                hover
                responsive
                v-if="items.length"
                class="mt-3"
                :items="items"
                :fields="fields"
                selectable
                select-mode="single"
                @row-selected="showData"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDir"
                @head-clicked="sortTable">
                <template #cell(statut)="data">
                  <div class="text-center" style="overflow: hidden; text-overflow: ellipsis" :title="data.value">
                    <span :title="data.value" :class="data.item.statusClass">{{ data.value }}</span>
                  </div>
                </template>
                <template #cell(fileNamee)="data">
                  <div class="text-center" style="overflow: hidden; text-overflow: ellipsis" :title="data.value">
                    <span :title="data.value" :class="data.item.statusClass">{{ data.item.fileNamee }}_{{ data.item.type }}_{{ data.item.id_format }}</span>
                  </div>
                </template>
                <template #cell()="data">
                  <div class="text-center" style="overflow: hidden; text-overflow: ellipsis">
                    <span :title="data.value">{{ data.value }}</span>
                  </div>
                </template>
              </b-table>
              <div v-else class="d-flex justify-content-center">
                <span class="noResult">
                  {{ $t("common.no_result") }}
                </span>
              </div>

              <b-row class="mt-5">
                <b-col>
                  <cm-pagination
                    :maxResultsByPage="paginationObject.maxResults"
                    :firstIndex="paginationObject.firstIndex"
                    :nbResultsTotal="paginationObject.nbResultsTotal"
                    :refreshEvent="paginationObject.refresh">
                  </cm-pagination>
                </b-col>
              </b-row>
              <b-row class="justify-content-end mt-5">
                <b-col lg="2" offset="7" class="mt-3">
                  <b-button variant="primary"
                    @click="exportList()">
                    <i class="fa-solid fa-arrow-up-from-bracket"></i>
                    {{ $t('pain008.extract_list') }}
                  </b-button>
                </b-col>
              </b-row>
            </div>
            <div v-else-if="currentTab === 'data'">
              <br />
              <b-row>
                <b-col md="2" cols="4" class="mb-2 text-left" v-if="canGoPrev">
                  <b-button @click="navDetails(-1)" class="btn">
                    <i class="fa-solid fa-chevrons-left"></i>
                    {{ $t('pain008.previous') }}
                  </b-button>
                </b-col>
                <b-col md="8" class="d-none d-lg-block"></b-col>
                <b-col md="2" cols="4" class="mb-2 text-right" v-if="canGoNext">
                  <b-button @click="navDetails(1)" class="btn">
                    {{ $t('pain008.next') }}
                    <i class="fa-solid fa-chevrons-right"></i>
                  </b-button>
                </b-col>
              </b-row>
              <div v-for="info in transactionData" class="container" :key="info.id">
                <br />
                <b-row class="justify-content-center text-center px-5" v-if="info.refTransaction && info.statut">
                  <b-col lg="4" class="p-0">
                    <div class="bandeau0">
                      {{ $t('pacs008.mandat_id') }}
                      <strong>{{info.mandatId}}</strong>
                    </div>
                  </b-col>
                  <b-col lg="4" class="p-0">
                    <div class="bandeau1">
                      Ref:
                      <strong>{{info.refTransaction}}</strong>
                    </div>
                  </b-col>
                  <b-col lg="4" class="p-0">
                    <div :class="info.statut !== 'Transmit' ? 'bandeau2': 'bandeau-success'">
                      {{info.statut}}
                    </div>
                  </b-col>
                </b-row>
                <b-row class="justify-content-between text-center">
                  <b-col md="3" cols="4">
                    <div class="py-4">
                      <label>{{ $t('pacs008.process_date') }}</label>
                      <p class="bloc-gris p-2">{{ info.processDate }}</p>
                    </div>
                  </b-col>
                  <b-col md="3" cols="4">
                    <div class="py-4">
                      <label>{{ $t('pacs008.amount') }}</label>
                      <p v-if="info.amount" class="bloc-gris p-2">
                        {{ info.amount + ' EUR' }}
                      </p>
                      <p v-else class="bloc-gris p-2">
                        {{ '-' }}
                      </p>
                    </div>
                  </b-col>
                  <b-col md="3" cols="4">
                    <div class="py-4">
                      <label>{{ $t('pacs008.reason') }}</label>
                      <p v-if="info.remittanceInfo" class="bloc-gris p-2">{{info.remittanceInfo}}</p>
                      <p v-else class="bloc-gris p-2">{{'-'}}</p>
                    </div>
                  </b-col>
                </b-row>
                <b-row class="justify-content-between mx-4">
                  <b-col lg="3" cols="12" class="bloc-transaction bloc-in mx-auto mb-3">
                    <div class="p-3 mt-4">
                      <p class="text-center font-weight-bold">
                        {{ $t('pacs008.comes_from_file') }}
                      </p>
                      <p v-if="info.protocol === 'webservice'" class="text-center word-break">
                        <br>
                        <i class="fa-solid fa-globe" :title="info.protocol"></i>
                        <br>
                        <br>
                        <u>MsgId :</u>
                        <br>
                        {{ info.fileNamee }}
                      </p>
                      <p v-else-if="info.protocol === 'interface'" class="text-center word-break">
                        <br>
                        <i class="fa-solid fa-file-arrow-up" :title="info.protocol"></i>
                        <br>
                        <br>
                        {{ info.fileNamee }}
                      </p>
                      <p class="text-center word-break" v-else>-</p>
                      <!-- <b-button
                        class="btn btn-red"
                        size="sm"
                        @click="redirectToFile(info.idIn)"
                      >
                        Voir ce fichier
                      </b-button> -->
                    </div>
                  </b-col>
                  <b-col lg="1" cols="12" class="my-auto text-center mb-3">
                    <i class="fa-duotone fa-arrow-right-long text-danger h2"></i>
                  </b-col>
                  <b-col lg="3" cols="12"
                    class="d-flex justify-content-around bloc-transaction bloc-info mx-auto mb-3">
                    <div class="p-3 my-auto">
                      <p class="text-center font-weight-bold">{{ $t('pacs008.transmitter') }}</p>
                      <p>{{ info.creditorName }}</p>
                      <p>{{ info.creditorBankAccount }}</p>
                      <p>{{ info.creditorBic }}</p>
                      <p v-if="info.creditorIcs">{{ info.creditorIcs }}</p>
                      <p v-else>-</p>
                    </div>
                    <div class="p-3 my-auto">
                      <p class="text-center font-weight-bold">{{ $t('pacs008.recipient') }}</p>
                      <p>{{ info.debtorName }}</p>
                      <p>{{ info.debtorBankAccount }}</p>
                      <p>{{ info.debtorBic }}</p>
                      <p>-</p>
                    </div>
                  </b-col>
                  <b-col lg="1" cols="12" class="my-auto text-center mb-3">
                    <i class="fa-duotone fa-arrow-right-long text-info h2"></i>
                  </b-col>
                  <b-col lg="3" cols="12" class="bloc-transaction bloc-out mx-auto mb-3">
                    <div class="p-3 mt-4 d-flex flex-column">
                      <p class="text-center font-weight-bold">
                        {{ $t('pacs008.content_in_pacs003') }}
                      </p>
                      <p class="text-center word-break" v-if="info.namePacss">
                        {{ info.namePacss }}
                      </p>
                      <p class="text-center" v-else>-</p>
                      <b-button
                        class="align-self-center"
                        variant="primary"
                        size="sm"
                        v-if="info.namePacss"
                        @click="redirectToFile(info.idOut, info.namePacss)">
                        {{ $t('pacs008.view_this_file') }}
                      </b-button>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </template>
  </page-outline>
</template>
<script>
import moment from "moment"
import PageOutline from "@/components/common/PageOutline.vue"
import Spinner from "@/components/common/spinner.vue"
import pagination from "@/components/common/pagination.vue"
import MessagesFilter from "@/pages/pacs008/components/FilterTransaction/index.vue"
import { errorMessageAlert } from "@/helpers/alert"
import {loadPage} from '@/helpers/routing'
import {statusLabel} from '@/helpers/labels'

export default {
  name: "TransactionList",
  components: {
    'cm-messages-filter': MessagesFilter,
    'cm-pagination': pagination,
    'page-outline': PageOutline,
    'spinner': Spinner
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  computed: {
    isSmartphoneOS() {
      return this.$f7.device.os === "android" || this.$f7.device.os === "ios"
    },
  },
  data() {
    return {
      activateSpinner: false,
      canGoPrev: false,
      canGoNext: false,
      completeList: [],
      currentIndex: 0,
      currentTab: "list",
      transactionData: [],
      fields: [
        {
          key: "processDate",
          label: this.$t("pacs008.process_date"),
          class: "text-center",
          sortable: true
        },
        {
          key: "refTransaction",
          label: this.$t("pacs008.end_to_end_id"),
          class: "text-center",
          sortable: true
        },
        {
          key: "fileNamee",
          label: this.$t("pacs008.msgId"),
          class: "text-center",
          sortable: true
        },
        // Quel est le plus pertinent entre creditor ics et creditor name?
        {
          key: "creditorIcs",
          label: this.$t("pacs003.creditor_ics"),
          class: "text-center",
          sortable: true
        },
        // {
        //   key: "creditorName",
        //   label: this.$t("pacs003.creditor_name"),
        //   class: "text-center",
        //   sortable: true,
        //   thClass: "w-25",
        // },
        {
          key: "creditorBankAccount",
          label: this.$t("pacs008.creditor_iban"),
          class: "text-center",
          sortable: false
        },
        {
          key: "debtorBic",
          label: this.$t("pacs008.debtor_bic"),
          class: "text-center",
          sortable: false
        },
        // A rajouter dans les details
        // {
        //   key: "mandatId",
        //   label: this.$t("pacs003.mandat_id"),
        //   class: "text-center",
        //   sortable: false,
        //   thClass: "w-50",
        // },
        {
          key: "statut",
          label: this.$t("pacs008.status"),
          class: "text-center",
          sortable: false
        },
        {
          key: "namePacss",
          label: this.$t("pacs003.file_name_pacs"),
          class: "text-center",
          sortable: true
        },
      ],
      filterConditions: {},
      items: [],
      mode: 1,
      fileNamee: '',
      paginationObject: {},
      sortBy: '',
      sortDir: false,
      statusClass: {
        '1': 'text-success',
        '2': 'text-danger',
        '0': 'text-danger'
      }
    }
  },
  created() {
    if (this.filterConditions) {
      if (this.filterConditions.OrderByField) {
        this.sortBy = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        this.sortDir = this.filterConditions.OrderByDirection === 'DESC'
      }
    }
    this.paginationObject["firstIndex"] = 1
    this.paginationObject["maxResults"] = 13
    this.paginationObject["nbResultsTotal"] = 0

    // if (this.id) {
    //   this.fileName = this.id
    // }
    this.paginationObject["refresh"] = "consultation-page"
    this.$bus.$off("consultation-page")
    this.$bus.$on("consultation-page", (index) => {
      that.onRefresh(false, index)
      that.pageCounter = 0
    })

    let that = this
    this.reload = false

    this.$f7.initPullToRefresh()
    this.pageCounter = 0
    let filterConditions = {}

    if (this.$engine.pacs008.CurrentNameFile) {
      filterConditions.CurrentNameFile = this.$engine.pacs008.CurrentNameFile
    }

    if (this.$engine.pacs008.CurrentFormat) {
      filterConditions.CurrentFormat = this.$engine.pacs008.CurrentFormat
    }

    if (this.$engine.pacs008.CurrentIdFormat) {
      filterConditions.CurrentIdFormat = this.$engine.pacs008.CurrentIdFormat
    }

    if (Object.keys(filterConditions).length) {
      this.applyFilter(filterConditions)
    } else {
      this.onRefresh(false)
    }
  },
  methods: {
    applyFilter(filterConditions, index = 1) {
      this.reload = true
      this.pageCounter = 0
      this.paginationObject["firstIndex"] = index
      this.paginationObject["nbResultsTotal"] = 0
      this.activateSpinner = true

      if (!Object.keys(filterConditions).length) {
        if (this.reload) {
          filterConditions = this.$engine.pacs008.filter.getConditionObject()
        } else {
          filterConditions = this.$engine.pacs008.filter.getDefaultFilter()
        }
      }

      if (filterConditions.requestIdentifier) {
        if (filterConditions.requestIdentifier.match(/[^\.]*[^_]*_[^_]*_[^_]*/)) {
          let nameFileArray = filterConditions.requestIdentifier.split("_")
          let nameFileArrayIdFormat = nameFileArray.pop()
          let nameFileArrayFormat = nameFileArray.pop()
          let nameFileArrayName = nameFileArray.join("_")
          filterConditions.CurrentNameFile = nameFileArrayName
          filterConditions.CurrentFormat = nameFileArrayFormat
          filterConditions.CurrentIdFormat = nameFileArrayIdFormat
        } else {
          filterConditions.CurrentNameFile = filterConditions.requestIdentifier
        }
      }

      // Filtre "Identifiant de la demande"
      // if (filterConditions.CurrentNameFile) {
      //   let nameFileArray = filterConditions.CurrentNameFile.split("_")
      //
      //   filterConditions.CurrentNameFile = nameFileArray.pop()
      //   filterConditions.CurrentNameFile = nameFileArray.pop()
      //   filterConditions.CurrentNameFile = nameFileArray.join("_")
      //   console.log(filterConditions.CurrentNameFile)
      // }

      if (this.filterConditions.OrderByField) {
        this.sortBy = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        this.sortDir = this.filterConditions.OrderByDirection === 'DESC'
      }

      this.$engine.pacs008
        .listTransactionsSDD(
          this.paginationObject.maxResults,
          this.paginationObject.firstIndex,
          filterConditions
        )
        .then((resp) => {
          let requests = {}

          this.paginationObject.nbResultsTotal = resp.data.nbTotalResults

          this.paginationObject.nbResults = resp.data.TransactionsSDD.length

          requests = resp.data.TransactionsSDD

          this.updateItems(requests)

          this.updateInbox(requests)
          this.$f7.pullToRefreshDone()
          this.$bus.emit(
            "refresh-cache-paging-template",
            this.paginationObject
          )
          if (this.$engine.pacs008.CurrentNameFile) {
            this.$engine.pacs008.CurrentNameFile = ""
          }

          if (this.$engine.pacs008.CurrentFormat) {
            this.$engine.pacs008.CurrentFormat = ""
          }

          if (this.$engine.pacs008.CurrentIdFormat) {
            this.$engine.pacs008.CurrentIdFormat = ""
          }
          this.activateSpinner = false
        })
        .catch((error) => {
          this.activateSpinner = false
          errorMessageAlert(error, this, this.$i18n)
        })
      this.currentTab = "list"
    },
    changeCurrentTab(newTab) {
      if (this.currentTab !== newTab) {
        this.currentTab = newTab
      }
    },
    exportList () {
      let filterConditions = {}
      if (this.reload) {
        filterConditions = this.$engine.pacs008.filter.getConditionObject()
      } else {
        filterConditions = this.$engine.pacs008.filter.getDefaultFilter()
      }
      if (this.fileNamee) {
        filterConditions.fileNamee = this.fileNamee
      }

      this.$engine.pacs008.getTransactionCsvSDD(
        filterConditions
      ).then( resp => {
        let list = {}
        list = resp.data.ExportTransaction
        this.updateList(list)
        this.extractCSV(this.completeList)
      }).catch(e => {
        errorMessageAlert(e, this, this.$i18n)
      })
    },
    extractCSV (completeList) {
      this.$f7.showPreloader(this.$i18n.t("common.loading_page_label"))
      let today = moment()
      let firstLine =
        this.$t("pacs008.process_date") + ";" +
        this.$t("pacs008.end_to_end_id") + ";" +
        this.$t("pacs008.file_name") + ";" +
        this.$t("pacs008.type_format") + ";" +
        this.$t("pacs008.file_id") + ";" +
        this.$t("pacs003.creditor_ics") + ";" +
        this.$t("pacs008.creditor_iban") + ";" +
        this.$t("pacs008.debtor_bic") + ";" +
        // this.$t("pacs003.mandat_id") +
        // ";" +
        this.$t("pacs008.status") + ";" +
        this.$t("pacs003.file_name_pacs") + "\r\n"
      let line = atob(this.completeList.data)
      let data = firstLine + line
      let linkSource = "data:text/csv;charset:utf-8;base64," + btoa(data)
      let downloadLink = document.createElement("a")
      let fileName = "Pacs003_" + today.unix() + ".csv"
      this.$f7.hidePreloader()

      downloadLink.href = linkSource
      downloadLink.download = fileName
      downloadLink.click()
    },
    navDetails (index) {
      this.$engine.pacs008.currentIndex = this.$engine.pacs008.currentIndex + index
      this.showData([{id: this.$engine.pacs008.listId[this.$engine.pacs008.currentIndex]}])
    },
    onRefresh(noAttach = false, index = 1) {
      this.pageCounter = 0
      this.paginationObject["firstIndex"] = index
      this.paginationObject["nbResultsTotal"] = 0
      this.activateSpinner = true
      let filterConditions

      if (this.reload) {
        filterConditions = this.$engine.pacs008.filter.getConditionObject()
      } else {
        filterConditions = this.$engine.pacs008.filter.getDefaultFilter()
      }

      if (this.filterConditions.OrderByField) {
        filterConditions.OrderByField = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        filterConditions.OrderByDirection = this.filterConditions.OrderByDirection
      }

      if (this.fileNamee) {
        filterConditions.fileNamee = this.fileNamee
      }

      this.$engine.pacs008
        .listTransactionsSDD(
          this.paginationObject.maxResults,
          this.paginationObject.firstIndex,
          filterConditions
        )
        .then((resp) => {
          let requests = {}

          this.paginationObject.nbResultsTotal = resp.data.nbTotalResults

          this.paginationObject.nbResults = resp.data.TransactionsSDD.length

          requests = resp.data.TransactionsSDD

          this.updateItems(requests)

          this.updateInbox(requests)
          this.$f7.pullToRefreshDone()
          this.$bus.emit(
            "refresh-cache-paging-template",
            this.paginationObject
          )
          this.activateSpinner = false
        })
        .catch((error) => {
          this.activateSpinner = false
          errorMessageAlert(error, this, this.$i18n)
        })

      this.currentTab = "list"
    },
    redirectToFile(id, namePacss) {
      this.$engine.pacs008.CurrentPacs003File = namePacss
      loadPage(this, {url: '/pacs008/SDD/consultation/' + id})
    },
    showData(item) {
      this.activateSpinner = true
      let transaction = item[0].id
      let that = this

      this.$engine.pacs008.currentIndex = this.$engine.pacs008.listId.indexOf(transaction)
      this.canGoPrev = this.$engine.pacs008.currentIndex > 0
      this.canGoNext = this.$engine.pacs008.currentIndex < (this.$engine.pacs008.listId.length - 1)

      this.$engine.pacs008
        .listTransactionsSDD(1, 1, { IdTransaction: transaction })
        .then((resp) => {
          let requests = []
          if (resp && resp.data) {
            requests.push(resp.data.TransactionsSDD)
            that.updateData(requests)
            that.$f7.pullToRefreshDone()
            that.$bus.emit(
              "refresh-cache-paging-template",
              this.paginationObject
            )

            that.currentTab = "data"
          } else {
            // return that.$f7.alert('pas de réponse', 'erreur')
          }
          that.activateSpinner = false
        })
        .catch((error) => {
          that.activateSpinner = false
          // errorMessageAlert(error, that, that.$i18n)
        })
      this.currentTab = "data"
    },
    sortTable (key, field, event, isFooter) {
      let sortDirection = 'ASC'
      if (key === this.sortBy && this.sortDir === false) {
        sortDirection = 'DESC'
      }

      this.filterConditions.OrderByField = key
      this.filterConditions.OrderByDirection = sortDirection

      this.applyFilter(this.filterConditions, this.paginationObject.firstIndex)
    },
    updateData(requests) {
      this.transactionData = []

      for (var i = 0; i < requests.length; i++) {

        let processDate = ""
        processDate = requests[i].ProcessDate
        if (processDate !== "") {
          processDate = moment(processDate).format("DD/MM/YYYY [à] HH[h]mm")
        } else {
          processDate = "-"
        }

        let statusLibelle = ''
        let statusClass = ''
        if (requests[i].Status != '') {
          statusLibelle = statusLabel(this.$i18n, "pacs008_0" + requests[i].Status)
          statusClass = this.statusClass[requests[i].Status]
        } else {
          statusLibelle = '-'
        }

        let result = {
          amount: requests[i].Amount,
          debtorBankAccount: requests[i].ContactBankAccount,
          debtorName: requests[i].ContactName,
          debtorBic: requests[i].ContactBic,
          creditorName: requests[i].HolderName,
          creditorBic: requests[i].HolderBic,
          creditorBankAccount: requests[i].HolderBankAccount,
          creditorIcs: requests[i].CreditorIcs,
          id: requests[i].IdTransaction,
          instructionId: requests[i].InstructionId,
          mandatId: requests[i].MandatId,
          refTransaction: requests[i].RefTransaction,
          remittanceInfo: requests[i].RemittanceInfo,
          processDate: processDate,
          statut: statusLibelle,
          statusClass: statusClass,
          fileIn: requests[i].fileIn,
          idOut: requests[i].idOut,
          fileNamee: requests[i].fileName,
          // idIn: requests[i].idIn,
          namePacss: requests[i].namePacs,
          type: requests[i].Type,
          id_format: requests[i].IdFormat,
          protocol: requests[i].Protocole
        }
        this.transactionData.push(result)
      }
    },
    updateInbox(requests) {
      this.inboxMessages = requests
    },
    updateItems(requests) {
      this.$engine.pacs008.listId = []

      this.items = []

      for (var i = 0; i < requests.length; i++) {

        this.$engine.pacs008.listId.push(requests[i].IdTransaction)

        let processDate = ""
        processDate = requests[i].ProcessDate
        if (processDate !== "") {
          processDate = moment(processDate).format("DD/MM/YYYY [à] HH[h]mm")
        } else {
          processDate = "-"
        }

        let statusLibelle = ''
        let statusClass = ''
        if (requests[i].Status != '') {
          statusLibelle = statusLabel(this.$i18n, "pacs008_0" + requests[i].Status)
          statusClass = this.statusClass[requests[i].Status]
        } else {
          statusLibelle = '-'
        }

        let result = {
          amount: requests[i].Amount,
          debtorBankAccount: requests[i].ContactBankAccount,
          debtorName: requests[i].ContactName,
          debtorBic: requests[i].ContactBic,
          creditorName: requests[i].HolderName,
          creditorBic: requests[i].HolderBic,
          creditorBankAccount: requests[i].HolderBankAccount,
          creditorIcs: requests[i].CreditorIcs,
          id: requests[i].IdTransaction,
          instructionId: requests[i].InstructionId,
          mandatId: requests[i].MandatId,
          refTransaction: requests[i].RefTransaction,
          remittanceInfo: requests[i].RemittanceInfo,
          processDate: processDate,
          statut: statusLibelle,
          statusClass: statusClass,
          fileIn: requests[i].fileIn,
          idOut: requests[i].idOut,
          fileNamee: requests[i].fileName,
          // idIn: requests[i].idIn,
          namePacss: requests[i].namePacs,
          type: requests[i].Type,
          id_format: requests[i].IdFormat,
          protocol: requests[i].Protocole
        }
        this.items.push(result)
      }
    },
    updateList(list) {
      this.completeList = list
    }
  },
}
</script>
